import { Helmet } from 'react-helmet-async';
import { useLang } from '@/context/LanguageContext';

const meta = {
  en: {
    title: 'MadisonFred | Web Design Agency',
    description: 'MadisonFred is a creative web design agency specializing in web design, development, branding, and UI/UX. We build bold digital products for ambitious brands.',
    keywords: 'web design agency, web development, branding, UI/UX design, digital products, creative studio',
    og_title: 'MadisonFred — We Craft Digital Experiences',
    og_description: 'A creative studio specializing in web design, development, branding, and UI/UX for ambitious brands.',
  },
  fr: {
    title: 'MadisonFred | Agence de Web Design',
    description: 'MadisonFred est une agence creative specialisee en web design, developpement, branding et UI/UX. Nous concevons des produits digitaux audacieux pour des marques ambitieuses.',
    keywords: 'agence web design, developpement web, branding, design UI/UX, produits digitaux, studio creatif',
    og_title: 'MadisonFred — Createurs d\'Experiences Digitales',
    og_description: 'Un studio creatif specialise en web design, developpement, branding et UI/UX pour des marques ambitieuses.',
  },
};

export default function SEOHead() {
  const { lang } = useLang();
  const m = meta[lang];

  return (
    <Helmet>
      <html lang={lang} />
      <title>{m.title}</title>
      <meta name="description" content={m.description} />
      <meta name="keywords" content={m.keywords} />
      <meta property="og:title" content={m.og_title} />
      <meta property="og:description" content={m.og_description} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={m.og_title} />
      <meta name="twitter:description" content={m.og_description} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={lang === 'en' ? 'https://madisonfred.com' : 'https://madisonfred.com/fr'} />
      <link rel="alternate" hrefLang="en" href="https://madisonfred.com" />
      <link rel="alternate" hrefLang="fr" href="https://madisonfred.com/fr" />
    </Helmet>
  );
}
